import {
  SET_UNITS,
  TOGGLE_PROJECT_DIALOG,
  SAVE_PROJECT_DATA,
  LOAD_PROJECTS,
  SELECT_PROJECT,
  DELETE_PROJECT,
  TOGGLE_SCENARIO_DIALOG,
  SAVE_SCENARIO_DATA,
  LOAD_SCENARIOS,
  SELECT_SCENARIO,
  DELETE_SCENARIO,
  SAVE_OBSTACLE_DATA,
  UPDATE_OBSTACLE_DATA,
  UPDATE_OBSTACLE_BY_GUID,
  SELECT_OBSTACLE,
  DELETE_OBSTACLE,
  DELETE_OBSTACLE_BY_GUID,
  SAVE_ATTACK_DATA,
  UPDATE_ATTACK_DATA,
  UPDATE_ATTACK_BY_GUID,
  SELECT_ATTACK,
  DELETE_ATTACK,
  DELETE_ATTACK_BY_GUID,
  RESET,
  SET_MAP_CHOICE,
  UPDATE_PROJECT_BUILDINGS,
  ACCEPT_T_AND_C,
  RESET_T_AND_C,
} from '../actionTypes'

export const setUnits = units => ({
  type: SET_UNITS,
  payload: units,
})

export const deleteProject = projectId => ({
  type: DELETE_PROJECT,
  payload: projectId,
})

export const deleteScenario = scenarioId => ({
  type: DELETE_SCENARIO,
  payload: scenarioId,
})

export const toggleScenarioDialog = () => ({
  type: TOGGLE_SCENARIO_DIALOG,
})

export const saveScenarioData = scenario => ({
  type: SAVE_SCENARIO_DATA,
  payload: scenario,
})

export const toggleProjectDialog = () => ({
  type: TOGGLE_PROJECT_DIALOG,
})

export const saveProjectData = project => ({
  type: SAVE_PROJECT_DATA,
  payload: project,
})

export const updateProjectBuildings = payload => ({
  type: UPDATE_PROJECT_BUILDINGS,
  payload: payload,
})

export const setMapChoice = choice => ({
  type: SET_MAP_CHOICE,
  payload: choice,
})

export const loadProjects = projects => ({
  type: LOAD_PROJECTS,
  payload: projects,
})

export const selectProject = projectId => ({
  type: SELECT_PROJECT,
  payload: projectId,
})

export const loadScenarios = scenarios => ({
  type: LOAD_SCENARIOS,
  payload: scenarios,
})

export const selectScenario = scenarioId => ({
  type: SELECT_SCENARIO,
  payload: scenarioId,
})

export const saveObstacleData = obstacle => ({
  type: SAVE_OBSTACLE_DATA,
  payload: obstacle,
})

export const saveAttackData = attack => ({
  type: SAVE_ATTACK_DATA,
  payload: attack,
})

export const updateObstacleData = (id, data) => ({
  type: UPDATE_OBSTACLE_DATA,
  payload: { id, data },
})

export const updateObstacleDataByGuid = (geom_guid, data) => ({
  type: UPDATE_OBSTACLE_BY_GUID,
  payload: { geom_guid, data },
})

export const updateAttackData = (id, data) => ({
  type: UPDATE_ATTACK_DATA,
  payload: { id, data },
})

export const updateAttackDataByGuid = (geom_guid, data) => ({
  type: UPDATE_ATTACK_BY_GUID,
  payload: { geom_guid, data },
})

export const selectObstacle = selectedObstacleGuid => ({
  type: SELECT_OBSTACLE,
  payload: selectedObstacleGuid,
})

export const selectAttack = selectedAttackGuid => ({
  type: SELECT_ATTACK,
  payload: selectedAttackGuid,
})

export const deleteObstacle = id => ({
  type: DELETE_OBSTACLE,
  payload: id,
})

export const deleteAttack = id => ({
  type: DELETE_ATTACK,
  payload: id,
})

export const deleteReduxObstacleByGuid = id => ({
  type: DELETE_OBSTACLE_BY_GUID,
  payload: id,
})

export const deleteReduxAttackByGuid = id => ({
  type: DELETE_ATTACK_BY_GUID,
  payload: id,
})

export const reset = () => ({
  type: RESET,
})

export const acceptTandC = () => ({
  type: ACCEPT_T_AND_C,
})

export const resetTandC = () => ({
  type: RESET_T_AND_C,
})
